module.exports = __webpack_public_path__ + "static/media/genjiMenu.a5791021.pdf";